import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
} from "@sttedra_ui/framework";

import CategoriesApiResponseModel from "./categories.api-response-model.js";
import CategoriesApiRequestModel from "./categories.api-request-model.js";

// #region Globals
const { base } = useAxios();
const timeout = 5000;
// #endregion

// #region Public functions
async function categoriesList(searchParams = {}) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = `/Category/list`;

    const { data: response } = await base.post(url, searchModel, {
      timeout,
    });

    const { data: originalData, pageSize, pageIndex, totalResults } = response;

    const data = originalData.map((u) => new CategoriesApiResponseModel(u));

    return {
      data,
      pageSize,
      pageIndex,
      totalResults,
    };
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al buscar los registros");

    return err;
  }
}

async function categoriesListAll(searchParams = {}) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = `/Category/listAll`;

    const response = await base.get(url, searchModel, {
      timeout,
    });

    const data = response.data.map((u) => new CategoriesApiResponseModel(u));

    data.sort((a, b) => a.orden - b.orden);

    return data;
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al buscar los registros");

    return err;
  }
}

async function categoriesCreate(params = {}) {
  try {
    const categoryModel = new CategoriesApiRequestModel(params);

    useDeleteNulls(categoryModel);

    const url = `/Category/addCategory`;

    const response = await base.post(url, categoryModel, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

async function categoriesUpdate(aliasCategoria, params = {}) {
  try {
    const categoryModel = new CategoriesApiRequestModel(params);

    useDeleteNulls(categoryModel);

    const url = `/Category/${aliasCategoria}/updateCategory`;

    const response = await base.put(url, categoryModel, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

async function categoriesUpdateOrder(categorySort) {
  try {
    const url = `/Category/updateCategorySort`;

    const response = await base.put(
      url,
      {
        categorySort,
      },
      {
        timeout,
      }
    );

    return response;
  } catch (err) {
    return err;
  }
}

async function categoriesDelete(aliasCategoria) {
  try {
    const url = `/Category/${aliasCategoria}/deleteCategory`;

    const response = await base.delete(url, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}
// #endregion

// #region Private functions
// #endregion

export {
  categoriesList,
  categoriesListAll,
  categoriesCreate,
  categoriesUpdate,
  categoriesUpdateOrder,
  categoriesDelete,
};
